import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
// import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";

export default function IdlePopup({
  setShowPopup,
  showPopup,
  data,
  setTrigger,
  trigger,
  setSelectedId,
}) {
  const [status, setStatus] = useState("");
  const statusOptions = [
    "REMOBILIZE",
    "ERE-EMERGENCY LEAVE",
    "ERE-ANNUAL VACATION",
    "ABSCONDING-RUN AWAY",
    "TERMINATION-FINAL EXIT",
    "RESIGNATION-FINAL EXIT",
    "NAKAL KAFALA-FINAL EXIT",
  ];

  const handleClose = () => {
    setShowPopup(false);
  };
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const dispatch = useDispatch();

  const token = localStorage.getItem("nodeToken");

  const onSubmit = async () => {
    const reqObj = {
      employee_id: data && data[0],
      demobilization_type: status,
    };
    if (status === "" || status === "undefined") {
      dispatch(
        setAppError({
          msg: "Status is required",
        })
      );
      return;
    }
    try {
      const response = await nodeinstance.put("/idleStatus/idle", reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setShowPopup(false);
        setTrigger(!trigger);
        setSelectedId([]);
        dispatch(
          setAppError({
            msg: "Employee Status changes successfully...",
            color: "success",
          })
        );
      }
    } catch (error) {
      console.log("error to be .....", error);
      dispatch(
        setAppError({
          msg: "Failed to update the status",
        })
      );
    }
  };
  return (
    <>
      {showPopup && (
        <div className="fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 flex justify-center items-center">
          <div className="max-w-lg w-full rounded-md bg-white/95 flex flex-col p-4 relative">
            <div className="flex justify-between items-center w-full">
              <h1
                className="text-md font-semibold cursor-pointer"
                onClick={handleClose}
              >
                <IoMdClose />
              </h1>
            </div>
            <div className="flex flex-col p-2 gap-1 w-full max-w-md flex-grow mt-5">
              <label htmlFor={`addOrEdit-name`} className="text-xs">
                CHANGE STATUS
              </label>
              <select
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                onChange={(e) => {
                  handleStatusChange(e);
                }}
              >
                <option value="">SELECT STATUS</option>
                {statusOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex w-full justify-center mt-10">
              <button
                className="w-full max-w-xs py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
                onClick={() => {
                  onSubmit();
                }}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
